export default __webpack_public_path__ + "media/images/fortpoint-bf8e0e08a49b88a9e4724ee4347dfe35.png";